function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.866 19.97C.866 9.334 9.49.71 20.124.71c10.66 0 19.258 8.625 19.258 19.26 0 10.658-8.6 19.257-19.258 19.257C9.49 39.227.866 30.627.866 19.97z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 6v12h4V6zm-8 4v8h4v-8zm16-2v10h4V8z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M16.584 5.518h4.88v12.988h-4.88z",
  strokeWidth: 0.79999995
}), React.createElement("path", {
  d: "M8.604 9.543h4.88v8.963h-4.88z",
  strokeWidth: 0.80000007
}), React.createElement("path", {
  d: "M24.61 7.566h4.884v10.94H24.61z",
  strokeWidth: 0.79999995
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.433 13.9c.968 0 1.937.348 2.676 1.068 1.476 1.416 1.476 3.726.023 5.166L19.788 34.216c-.714.72-1.682 1.068-2.65 1.068h-.026c-.968.025-1.937-.347-2.676-1.043l-6.523-6.33c-1.478-1.44-1.478-3.75-.025-5.19 1.452-1.44 3.847-1.44 5.325-.026l3.874 3.775 11.696-11.5c.74-.72 1.707-1.068 2.65-1.068z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.663 13.562c.988 0 1.976.357 2.73 1.096 1.51 1.454 1.51 3.826.027 5.305l-14.645 14.46c-.728.74-1.717 1.096-2.705 1.096h-.026c-.988.024-1.977-.36-2.73-1.073l-6.66-6.503c-1.51-1.48-1.51-3.85-.026-5.33 1.482-1.48 3.928-1.48 5.436-.025l3.954 3.875 11.94-11.808c.754-.74 1.742-1.096 2.705-1.096z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M.533 20.035c0-10.762 8.73-19.49 19.49-19.49 10.79 0 19.493 8.728 19.493 19.49 0 10.788-8.704 19.492-19.492 19.492-10.762 0-19.49-8.704-19.49-19.492",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.79999989,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgInsightSubmenuKeepup = function SvgInsightSubmenuKeepup(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsightSubmenuKeepup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Insight-submenu-keepup.e32d81f9.svg";
export { ForwardRef as ReactComponent };